// extracted by mini-css-extract-plugin
module.exports = {"root":"_292cf54","labelContent":"_537efca"};